import type { ICartItem, ICtaClick, IItem, IPurchase } from '@/shared/interfaces/IAnalytics'

declare global {
  interface Window {
    [key: string]: unknown[]
  }
}

export default {
  Impressions(items: IItem[], dataLayerName = 'dataLayer'): void {
    window[dataLayerName]?.push({ ecommerce: null })
    window[dataLayerName]?.push({
      event: 'view_item_list',
      ecommerce: {
        items
      }
    })
  },
  AddToCart(item: ICartItem, dataLayerName = 'dataLayer'): void {
    window[dataLayerName]?.push({ ecommerce: null })
    const pack: IItem = {
      item_id: item.id,
      item_name: item.name,
      price: item.value,
      item_category: item.category,
      quantity: 1
    }
    window[dataLayerName]?.push({
      event: 'add_to_cart',
      ecommerce: { items: [pack] }
    })
  },
  Purchase(purchase: IPurchase, dataLaterName = 'dataLayer'): void {
    window[dataLaterName]?.push({ ecommerce: null })
    const pack: IItem = {
      item_id: purchase.id,
      item_name: purchase.name,
      price: purchase.value,
      item_category: purchase.category,
      quantity: 1
    }
    window[dataLaterName]?.push({
      event: 'purchase',
      ecommerce: {
        transaction_id: purchase.folio,
        value: purchase.value,
        tax: purchase.tax,
        currency: purchase.currency,
        items: [pack]
      }
    })
  },
  CtaClick(ctaClick: ICtaClick, dataLayerName = 'dataLayer'): void {
    window[dataLayerName]?.push({
      event: 'cta_click',
      cta_name: ctaClick.cta_name,
      source_url: ctaClick.source_url,
      destination_url: ctaClick.destination_url,
      country: ctaClick.country
    })
  }
}
